import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobInstanceHistoryQueryVariables = Types.Exact<{
  instanceName: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type JobInstanceHistoryQuery = { __typename: 'Query', jobInstanceHistory: Array<{ __typename: 'JobInstanceHistoryEvent', source: string, observedAt: string, eventType: string, message?: string | null, taskUuid?: string | null, taskLegacyId?: number | null, jobLegacyId?: number | null, taskType?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, durationSeconds?: number | null, status?: string | null, previousStatus?: string | null, reason?: string | null }> };

export const JobInstanceHistoryDocument = gql`
    query JobInstanceHistory($instanceName: String!, $limit: Int) {
  jobInstanceHistory(instanceName: $instanceName, limit: $limit) {
    source
    observedAt
    eventType
    message
    taskUuid
    taskLegacyId
    jobLegacyId
    taskType
    resourceGroupId
    advanceReason
    durationSeconds
    status
    previousStatus
    reason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobInstanceHistoryGQL extends Apollo.Query<JobInstanceHistoryQuery, JobInstanceHistoryQueryVariables> {
    override document = JobInstanceHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }